var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-btn',{attrs:{"small":"","outlined":"","color":"warning"},on:{"click":_vm.downloadCodes}},[_vm._v("Download Recovery Codes")]),_c('div',{staticClass:"recovery-code-block"},_vm._l((_vm.recoveryCodes),function(code,index){return _c('div',{key:index},[_vm._v(" "+_vm._s(code)+" ")])}),0)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }